/**
 * 候场名单（主持人可见）：谁在门外、等了多久，逐个准入或拒绝，也可一键全部准入。
 * 没人候场时整块不渲染 —— 不占地方，也不会让人以为「有东西要处理」。
 */

import { useEffect, useState } from 'react'

import { useRoomStore } from '../stores/roomStore'

export function WaitingPanel() {
  const list = useRoomStore((s) => s.waitList)
  const admit = useRoomStore((s) => s.admitWaiter)
  const reject = useRoomStore((s) => s.rejectWaiter)
  // 每秒重算等待时长。
  const [, tick] = useState(0)
  useEffect(() => {
    if (list.length === 0) return
    const t = window.setInterval(() => tick((n) => n + 1), 1000)
    return () => window.clearInterval(t)
  }, [list.length])

  if (list.length === 0) return null

  return (
    <div className="panel wait-panel">
      <div className="panel-head">
        等候室
        <em className="wait-count">{list.length}</em>
        {list.length > 1 && (
          <button className="wait-all" onClick={() => admit(0, true)}>
            全部准入
          </button>
        )}
      </div>
      <ul className="wait-list">
        {list.map((w) => (
          <li key={w.waitId} className="wait-item">
            <span className="wait-name" title={w.account}>
              {w.name || w.account}
            </span>
            <span className="wait-since">{since(w.since)}</span>
            <span className="wait-acts">
              <button className="primary" onClick={() => admit(w.waitId)}>
                准入
              </button>
              <button className="wait-no" onClick={() => reject(w.waitId)}>
                拒绝
              </button>
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}

/** 从进入等候室的时刻算出「等了多久」。 */
function since(sec: number): string {
  const d = Math.max(0, Math.floor(Date.now() / 1000) - sec)
  if (d < 60) return `${d} 秒`
  return `${Math.floor(d / 60)} 分`
}
